import { last, split, startsWith } from 'lodash/fp';

const BASE_URL = 'https://ahm.com.au';

// @ts-expect-error - Automatic, Please fix when editing this file
const extractRelativePath = (perk) => {
  if (perk?.descriptionTeaser && perk?.identifier?.current) {
    return `/perks/${perk.identifier.current}`;
  }

  const url = perk?.urlObject?.url;
  if (startsWith(BASE_URL, url)) {
    return last(split(BASE_URL, url));
  }

  return url;
};

export default extractRelativePath;
